import { apolloClient } from '~/apollo-client';
import { ContractVersion } from '~/services/fetch-vnm-terms';
import {
  Flex_CreateContractAgreementsMutation,
  Flex_CreateContractAgreementsMutationVariables,
} from '~/typings/graphql';
import { CREATE_CONTRACT_AGREEMENT } from './agree-to-terms.queries';

export const agreeToTerms = async (params: AgreeToTermsParams): Promise<AgreeToTermsResponse> => {
  const { userId, utilityAccountId, vnmSolarProjectContracts, selfAttestationContracts } = params;
  const contracts = selfAttestationContracts || vnmSolarProjectContracts;
  if (!contracts?.length) return;

  const input = contracts.map(contract => ({
    contractVersionId: contract.id,
    contractVersionLanguageId: contract.contractVersionLanguageId,
    userAgent: navigator.userAgent,
    userId,
    utilityAccountId,
  }));

  await apolloClient.mutate<
    Flex_CreateContractAgreementsMutation,
    Flex_CreateContractAgreementsMutationVariables
  >({
    mutation: CREATE_CONTRACT_AGREEMENT,
    variables: { input },
  });
};

type AgreeableContract = Pick<ContractVersion, 'id' | 'contractVersionLanguageId'>;

export interface AgreeToTermsParams {
  userId: number;
  utilityAccountId?: number;
  vnmSolarProjectContracts?: AgreeableContract[];
  selfAttestationContracts?: AgreeableContract[];
}

export type AgreeToTermsResponse = void;
